import React from "react"
import FormattedMessage from "@irati/utils/lang"
import {Chevron, Divider, ShowMoreContainer, ShowMoreText, Wrapper} from "./styled"

type ShowMoreProps = {
  isShowingMore?: boolean
  handleShowMoreClick?: () => void
  displayShowMoreText?: boolean
}

export const ShowMore: React.FC<ShowMoreProps> = ({
  isShowingMore = false,
  handleShowMoreClick = () => {},
  displayShowMoreText = false
}) => {
  return (
    <Wrapper>
      {displayShowMoreText ? (
        <ShowMoreContainer onClick={handleShowMoreClick}>
          <Divider />
          <ShowMoreText>
            {isShowingMore ? (
              <FormattedMessage id="wellness.categories.showMore.showLess" />
            ) : (
              <FormattedMessage id="wellness.categories.showMore.showMore" />
            )}
            <Chevron className={isShowingMore ? "fa fa-chevron-up" : "fa fa-chevron-down"} />
          </ShowMoreText>
          <Divider />
        </ShowMoreContainer>
      ) : (
        <Divider />
      )}
    </Wrapper>
  )
}
